import {  
    getFirestore,
    collection,
    addDoc,
    updateDoc,
    doc,
    increment
} from "firebase/firestore";
const addRewardRedemption = async function(rewardId, data) {
    let db = getFirestore();
    let ref = collection(db, "wellness_rewards", rewardId, "redeem_history");
    const result = await addDoc(ref, data);
    await updateDoc(doc(db, "wellness_rewards", rewardId), {
        redeemCount: increment(1)
    });
    return result.id;
};
export default addRewardRedemption;